import { render } from "./CourseraForm.vue?vue&type=template&id=4a3c0b77&scoped=true"
import script from "./CourseraForm.vue?vue&type=script&lang=js"
export * from "./CourseraForm.vue?vue&type=script&lang=js"

import "./CourseraForm.vue?vue&type=style&index=0&id=4a3c0b77&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a3c0b77"]])

export default __exports__